import React from 'react'
import './Feed.scss';
import theme from '../../shared/Theme/Theme';
import Chat from '../../components/Chat/Chat';
import Button from '@material-ui/core/Button';
import {makeStyles} from '@material-ui/core/styles';

import CreateAPost from '../../components/CreateAPost/CreateAPost';

const useStyles = makeStyles(theme => ({

}));

function Feed() {

    const classes = useStyles();

    return (
        <div>
            <CreateAPost/>
            <div className="comment-container">

            </div>
            <Chat/>
        </div>
    );
}

export default Feed

// import Comment from '@material-ui/icons/ModeComment';
/*
{[...new Array(12)]
    .map(
    () => `Cras mattis consectetur purus sit amet fermentum.
Cras justo odio, dapibus ac facilisis in, egestas eget quam.
Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`,
    )
.join('\n')}
*/